import { auth, db } from "../../../firebaseConfig"; // Make sure to import your Firebase configuration
import { doc, setDoc } from "firebase/firestore";
import { getSelectedUid } from "../../../../frontend/Recruitment/Applications/Utils/UidListener";


// Function to save form data for Section 5
export const writeDataS5 = async (formData) => {
  const userId = getSelectedUid(); // Get the selected UID
  if (!userId) {
    throw new Error("Invalid user.");
  }
  try {
    const docRef = doc(
      db,
      "Advisers",
      userId,
      "Application Details",
      "Accountant Details"
    );

    await setDoc(
      docRef,
      {
        ...formData,
      },
      { merge: true }
    );
    // console.log("Section 5 data successfully written to Firestore!");
  } catch (error) {
    // console.error("Error writing Section 5 data to Firestore: ", error);
  }
};
